import { useLocation } from "react-router-dom";
import styled, { css } from "styled-components";
import { useEffect, useState } from "react";
import ArrowLeftIcon from "../icon/arrowLeftIcon";
import ArrowRightIcon from "../icon/arrowRightIcon";
import { Image } from "../common/image";
import CloseIcon from "../icon/closeIcon";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* outline: 1px solid green; */
  height: 100vh;
  /* margin-bottom: 5vw; */
  background-color: #282828;
`;
const ContainerBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  /* outline: 10px solid red; */
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  -ms-transform: rotate(90deg); // IE 9 이상에서 사용
  -webkit-transform: rotate(90deg); // 사파리, 크롬, 오페라 브라우저 사용
  transform: rotate(90deg);
  /* background-color: #ffffff;
  box-shadow: 0 0.5vh 0.5vh rgba(0, 0, 0, 0.03),
    0 0.5vh 0.5vh rgba(0, 0, 0, 0.003); */
  border-radius: 1vw;
  width: 100vh;
  height: 95vw;
  /* outline: 1px solid red; */
`;
const ImageTitle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  height: 7vw;
  color: #ffffff;

  /* outline: 1px solid red; */
  font-size: 3vw;
`;
const ImageBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-color: #ffffff; */
  border-radius: 1vw;
  width: 94%;
  height: 80%;
  /* outline: 1px solid red; */
`;

const StyledImage = styled(Image)`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
`;

const ListText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  font-size: 2vw;
`;
const PrevBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 5vw;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#676767")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;

const NumBox = styled.div`
  width: 13vw;
  height: 5vw;
  background-color: #676767;
  border-radius: 0.4vw;
  display: flex;
  color: #ffffff;
  justify-content: center;
  align-items: center;
  font-size: 2.4vw;
  font-weight: 600;
`;

const NextBox = styled.div<{ $isActivate: boolean }>`
  width: 5vw;
  height: 5vw;
  background-color: ${(props) => (props.$isActivate ? "#ff7f3b" : "#676767")};
  border-radius: 0.4vw;
  display: flex;
  justify-content: center;
  align-items: center;
  ${(props) =>
    !props.$isActivate &&
    css`
      pointer-events: none;
    `}
`;
const MidArea = styled.div`
  width: 30%;
  height: 8%;
  display: flex;
  justify-content: space-around;
  align-items: end;
  /* outline: 1px solid red; */
`;
const BottomArea = styled.div`
  width: 90%;
  height: 20%;
  display: flex;
  justify-content: space-around;
  /* outline: 1px solid red; */
  flex-wrap: wrap;
  justify-content: start;
`;
const ThumbnailBox = styled.div<{ $index: number; $currentPage: number }>`
  width: 7vw;
  height: 9vw;
  outline: 0.1vw solid #ffffff;
  margin-right: 1vw;
  margin-bottom: 1.2vw;
  background-color: #ffffff;
  box-shadow: 0 0.5vh 0.5vh rgba(0, 0, 0, 0.02),
    0 0.5vh 0.5vh rgba(0, 0, 0, 0.002);
  border-radius: 0.3vw;
  ${(props) =>
    props.$index === props.$currentPage - 1 &&
    css`
      outline: 0.3vw solid #ff7f3b;
    `}
  &:hover {
    cursor: pointer;
  }
`;

const CloseBox = styled.div`
  display: flex;
  align-items: center;
  background-color: #ffffff16;
  padding: 1vw;
  border-radius: 0.5vw;
  justify-content: end;
  &&:hover {
    cursor: pointer;
  }
`;
const Close = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
`;
const HeaderBox = styled.div`
  display: flex;
  width: 94%;
  align-items: center;
  justify-content: space-between;
`;
export default function IntroductionImageView() {
  const {
    state: {
      item: { id, name, lastModified, CompanyProfileImage },
    },
  } = useLocation();
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [maxIndex, setMaxIndex] = useState<number>(CompanyProfileImage.length);
  const [prevBoxActive, setPrevBoxActive] = useState<boolean>(false);
  const [nextBoxActive, setNextBoxActive] = useState<boolean>(true);

  const historyBack = () => {
    window.history.back();
  };
  const clickPrevPage = (e: any) => {
    if (currentPage <= 1) {
      return;
    } else {
      setCurrentPage(currentPage - 1);
    }
  };

  const clickNextPage = (e: any) => {
    if (currentPage >= maxIndex) {
      return;
    }
    setCurrentPage(currentPage + 1);
  };
  const openContractImage = (path: string) => {
    window.open(`https://homenmove.net/${path}`);
  };

  const onclickThumbnail = (index: number) => {
    setCurrentPage(index + 1);
  };
  useEffect(() => {
    if (currentPage <= 1) {
      setPrevBoxActive(false);
      setNextBoxActive(true);
    } else {
      setPrevBoxActive(true);
      if (currentPage >= maxIndex) {
        setNextBoxActive(false);
      } else {
        setNextBoxActive(true);
      }
    }
  }, [currentPage]);

  useEffect(() => {
    setMaxIndex(CompanyProfileImage.length);
  }, [CompanyProfileImage]);
  return (
    <>
      <Container>
        <ContainerBox>
          <ListContainer>
            <HeaderBox>
              <Close></Close>
              <ImageTitle>{name}</ImageTitle>
              <CloseBox>
                <CloseIcon
                  onClick={historyBack}
                  height={"3vw"}
                  fill={"#AEAEAE"}
                />
              </CloseBox>
            </HeaderBox>
            <ImageBox>
              {CompanyProfileImage.map((item: any, index: number) => {
                if (index + 1 === currentPage) {
                  return (
                    <StyledImage
                      onClick={(e: any) => openContractImage(item.path)}
                      src={`https://homenmove.net/${item.path}`}
                      width={"100%"}
                      height={"100%"}
                      // height={"100%"}
                      key={index}
                    ></StyledImage>
                  );
                }
              })}
            </ImageBox>
            <MidArea>
              <PrevBox $isActivate={prevBoxActive}>
                <ArrowLeftIcon
                  onClick={(e: any) => clickPrevPage(e)}
                  width={"4.2vw"}
                  height={"4.2vw"}
                  fill={"white"}
                />
              </PrevBox>
              <NumBox>
                {currentPage} / {maxIndex}
              </NumBox>
              <NextBox $isActivate={nextBoxActive}>
                <ArrowRightIcon
                  onClick={(e: any) => clickNextPage(e)}
                  width={"4.2vw"}
                  height={"4.2vw"}
                  fill={"white"}
                />
              </NextBox>
            </MidArea>
          </ListContainer>
        </ContainerBox>
        {/* <BottomArea>
          {CompanyProfileImage.map((item: any, index: number) => {
            return (
              <ThumbnailBox
                key={item}
                index={index}
                $currentPage={currentPage}
                onClick={(e: any) => onclickThumbnail(index)}
              >
                <Image
                  src={`https://homenmove.net/${item.path}`}
                  width={"100%"}
                  height={"100%"}
                ></Image>
              </ThumbnailBox>
            );
          })}
        </BottomArea> */}
      </Container>
    </>
  );
}
